import React from 'react'
import BlogListing from './BlogListing'
import BlogsGrid from './BlogsGrid'
import SecondBlogsGrid from './SecondBlogsGrid'
import ListViewBlogsGrid from './ListViewBlogsGrid'
import TimelineViewBlogsGrid from './TimelineViewBlogsGrid'
import { useSelector } from 'react-redux'

function BlogsWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.theme_blog === "grid" ? (
        <BlogsGrid />
      ) : sitedata?.theme_blog === "list" ? (
        <ListViewBlogsGrid />
      ) : sitedata?.theme_blog === "time-line" ? (
        <TimelineViewBlogsGrid />
      ) : sitedata?.theme_blog === "static-card-grid" ? (
        <BlogListing />
      ) : (
        <SecondBlogsGrid />
      )}
    </>
  )
}

export default BlogsWrapper